export const INFO_MESSAGE = [
  {
    code: 'M0000',
    message: ''
  },
  {
    code: 'M0001',
    message: '選択し直してください。'
  },
  {
    code: 'M0002',
    message: '入力し直してください。'
  },
  {
    code: 'M0003',
    message: 'データがありません。条件を変更してください。'
  },
  {
    code: 'M0004',
    message: 'Now Loading'
  },
  {
    code: 'M0005',
    message: '検索結果が多すぎます。検索条件を絞り込んでください。'
  },
  {
    code: 'M0006',
    message: 'データがありません。'
  },
  {
    code: 'M0007',
    message: 'あと{0}機種まで追加可能'
  },
  {
    code: 'M0008',
    message: 'これ以上追加できません'
  },
  {
    code: 'M0009',
    message: 'チェックをつけた機種の推移をグラフで表示することができます（最大{0}機種）'
  }
];

export const KUBUN_ERROR = 'KUBUN_ERROR';
export const CALENDER_ERROR = 'CALENDER_ERROR';
export const SHUBETSU_ERROR = 'SHUBETSU_ERROR';
export const PS_ERROR = 'PS_ERROR';
export const RATE_ERROR = 'RATE_ERROR';
export const NOHINKAISHIBI_ERROR = 'NOHINKAISHIBI_ERROR';
export const TYPE_ERROR = 'TYPE_ERROR';
export const MAKER_ERROR = 'MAKER_ERROR';
export const KISHU_TEXT_ERROR = 'KISHU_TEXT_ERROR';
export const KISHU_ERROR = 'KISHU_ERROR';
